import { Toast, useConfirm } from '@whelk/components';
import { deleteChatHistories, postDeleteMessage } from '@whelk/services/src/chat';
import { RootState, store } from '@whelk/store';
import { useTranslation } from 'react-i18next';
import { useChat } from '../..';
import useChatEditor from './useChatEditor';
import { trackCustomEvent, TrackParams } from '@whelk/utils';
import { TRACK_KEYS, WINDOW_CLICK_TYPE } from '@whelk/const/src/trackSpec';
import { useDispatch, useSelector } from 'react-redux';
import { deleteHistoryListItems, setSelectedChatIds } from '@whelk/store/slices/historyListSlice';
import { HOME_URL } from '@whelk/const/src/routerUrl';
import { isApiError } from '@whelk/services/src/common';
import { useRouter } from '../useRouter';

export default function useDeleteChat() {
  const { showConfirm } = useConfirm();
  const nav = useRouter();
  // const { setOpen } = useRightTabsModel();
  const { addNewChat } = useChat();
  const dispatch = useDispatch();
  const { onDeleteCurrentChatMsgIds } = useChatEditor();
  const { t } = useTranslation();
  const currentChatId = useSelector((state: RootState) => state.chat.chatId);

  const onConfirm = async (msgId: string) => {
    try {
      const checkedMsgIds = [msgId];
      const chatList = store.getState()?.chat?.chatList || [];
      await postDeleteMessage({ msgIDs: checkedMsgIds });
      Toast.success(t('toast_delete_msg_success'));
      // setOpen(false);
      // 如果删除的是全部对话，那么就刷新列表
      if (chatList.length <= checkedMsgIds.length * 2) {
        addNewChat();
      } else {
        // 如果删除部分对话 刷新对话列表
        // onActiveTargetHistoryItem();
        onDeleteCurrentChatMsgIds(checkedMsgIds);
      }
    } catch (err) {
      console.error(err);
      Toast.error(t('toast_delete_msg_fail'));
    }
  };

  const onDeleteChat = (msgId: string) => {
    showConfirm({
      title: t('general_delete'),
      content: t('text_delete_msg'),
      onOk: () => {
        onConfirm(msgId);
      },
      onCancel: () => {
        console.log('用户取消了操作');
      },
    });
  };

  const confirmDeleteHistory = async (chatIds: string[], trackParams?: TrackParams) => {
    trackCustomEvent({
      id: 'chat_delete_popup_wnd_click',
      [TRACK_KEYS.CHAT_ID_LIST]: chatIds.join(','),
      [TRACK_KEYS.CHAT_NUM]: chatIds.length,
      [TRACK_KEYS.CLICK_TYPE]: WINDOW_CLICK_TYPE.CONFIRM,
      ...trackParams,
    });
    try {
      await deleteChatHistories(chatIds);
      Toast.success(t('toast_delete_msg_success'));
      dispatch(deleteHistoryListItems(chatIds));
      dispatch(setSelectedChatIds({ chatIds: [], isSelectingAll: false }));
      if (chatIds[0] === currentChatId) {
        nav.replace(HOME_URL);
      }
    } catch (err) {
      if (isApiError(err)) {
        Toast.error(err.message);
      }
    }
  };

  const onDeleteHistory = ({
    chatIds,
    trackParams,
  }: {
    chatIds: string[];
    trackParams?: TrackParams;
  }) => {
    showConfirm({
      title: t('delete_comfirm_popup', { count: chatIds.length }),
      content: t('delete_selected_conversation_confirmation', { count: chatIds.length }),
      onOk: () => {
        confirmDeleteHistory(chatIds, trackParams);
      },
      onCancel: () => {
        chatIds &&
          trackCustomEvent({
            id: 'chat_delete_popup_wnd_click',
            [TRACK_KEYS.CHAT_ID_LIST]: chatIds.join(','),
            [TRACK_KEYS.CHAT_NUM]: chatIds.length,
            [TRACK_KEYS.CLICK_TYPE]: WINDOW_CLICK_TYPE.CANCEL,
            ...trackParams,
          });
      },
    });
  };

  return {
    onDeleteChat,
    onDeleteHistory,
  };
}
